import {
  Box,
  Button,
  Flex,
  Text,
  ButtonGroup,
  Grid,
  GridItem,
  Textarea,
  Input,
  VisuallyHidden,
  AlertIcon,
  Alert,
  AlertTitle,
  AlertDescription,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Tooltip,
  Badge,
} from "@chakra-ui/react";
import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
} from "@chakra-ui/react";
import { FileIcon, RemoveIcon } from "../../assets/svgs/Icons";
import moment from "moment";
import React, { useState } from "react";
import { useEffect } from "react";
import { FiUpload } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import {
  approveApplication,
  getIncomingApplicationById,
  getIncomingExApplicationById,
  postAssignToMe,
  rejectApplication,
} from "./ContractorSlice";
import { toast, useToast } from "react-toastify";
import axios from "axios";
import isAllowed from "../../routing/isAllowed";
import { useNavigate } from "react-router-dom";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import { DocumentViewer } from "../../Components/common/DocumentViewer";
import DOCUMENT_FROM from "../../Common/Constants";
import { checkFileTypesAndSize } from "../../Common/utils";
import CustomAlertDialog from "../../Components/CustomAlertDialog";

function RCFormUploadDocuments() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [status, setStatus] = useState("idle");
  const { exApplication: application } = useSelector(
    (state) => state.contractor
  );
  const [isLoading, setIsLoading] = useState(false);
  const [paymentFile, setPaymentFile] = useState();
  const [offerLetterFile, setOfferLetterFile] = useState(null);
  const [comment, setComment] = useState("");
  const [assign, setAssign] = useState(false);
  const [remarks, setRemarks] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessage1, setErrorMessage1] = useState("");
  const [isOpenMod, setIsOpenMod] = useState(false);
  const navigate = useNavigate();
  const { userData } = useSelector((state) => state.auth);
  const applicationRenewStatus = "extension";

  const handleGoBack = () => navigate(-1);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const validation = checkFileTypesAndSize(
      file.name,
      file.type,
      file.size,
      10485760
    );
    if (!validation.isValid) {
      toast.error(validation.error);
      setErrorMessage(validation.error);
      return;
    }
    setPaymentFile(file);
    toast.success("Payment reference document uploaded successfully");
    setErrorMessage("");
  };

  const handleOfferUpload = (e) => {
    const file = e.target.files[0];
    const validation = checkFileTypesAndSize(
      file.name,
      file.type,
      file.size,
      10485760
    );
    if (!validation.isValid) {
      toast.error(validation.error);
      setErrorMessage1(validation.error);
      return;
    }
    setOfferLetterFile(file);
    toast.success("Offer letter document uploaded successfully");
    setErrorMessage1("");
  };

  const clearErrorMessage = () => setErrorMessage("");
  const clearErrorMessage1 = () => setErrorMessage1("");

  const token = localStorage.getItem("cu_user");

  const handleSubmit = async () => {
    if (!paymentFile || !offerLetterFile) {
      return toast.info("Upload supporting documents");
    }
    setIsLoading(true);
    const paymentFileFormData = new FormData();
    const offerletterFormData = new FormData();
    paymentFileFormData.append("document", paymentFile);
    paymentFileFormData.append("doc_type", "PAYMENT-REFERENCE");
    paymentFileFormData.append("userType", "ADMIN");
    paymentFileFormData.append("documentInfo", "PAYMENT-REFERENCE");
    offerletterFormData.append("document", offerLetterFile);
    offerletterFormData.append("doc_type", "CONTRACTOR-OFFER-LETTER");
    offerletterFormData.append("userType", "ADMIN");
    offerletterFormData.append("documentInfo", "CONTRACTOR-OFFER LETTER");
    try {
      const paymentFileRequest = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_HOST}/api/document`,
        data: paymentFileFormData,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      const offerLetterRequest = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_HOST}/api/document`,
        data: offerletterFormData,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      if (offerLetterRequest.data && paymentFileRequest.data) {
        const values = {
          comment: comment,
          offerLetter: offerLetterRequest?.data?.data?.id,
          paymentReference: paymentFileRequest?.data?.data?.id,
        };
        dispatch(
          approveApplication({ id: id, values, applicationRenewStatus })
        );
        navigate(-1);
        setIsLoading(false);
      }
      setPaymentFile();
      setOfferLetterFile();
      setComment("");
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
    onCloseMod();
  };

  const getList = async (id) => {
    try {
      setStatus("pending");
      await dispatch(getIncomingExApplicationById(id));
    } catch (error) {
      window.alert(error);
    }
  };

  const assignToMe = (id) => {
    setIsLoading(true);
    try {
      setStatus("pending");
      dispatch(postAssignToMe({ id, applicationRenewStatus }));
      setIsLoading(false);
      navigate(-1);
    } catch (error) {
      setIsLoading(false);
      console.error(error, "error");
    }
  };

  const rejectApplicationForm = (id) => {
    setIsLoading(true);
    try {
      setStatus("pending");
      dispatch(rejectApplication({ id, applicationRenewStatus }));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
    onClose();
    navigate(-1);
  };

  const [isOpen, setIsOpen] = useState(false);
  const onClose = () => setIsOpen(false);
  const onCloseMod = () => setIsOpenMod(false);

  useEffect(() => {
    getList(encodeURIComponent(id));
  }, []);

  useEffect(() => {
    const filteredRemarks = application?.remarks?.filter(
      (data) => data.comment
    );
    setRemarks(filteredRemarks);
  }, [application]);

  // Shared text styles
  const labelProps = {
    color: "#141D43",
    fontSize: "md",
    fontWeight: "700",
    fontFamily: "font.roboto",
  };
  const valueProps = {
    color: "#464C64",
    fontSize: "sm",
    marginTop: "1rem",
    wordBreak: "break-word",
    overflowWrap: "break-word",
  };

  return (
    <Box
      marginBottom={"2rem"}
      padding={{ base: "1rem", md: "2rem", lg: "3rem" }}
    >
      {/* Go Back */}
      <Box
        display={"flex"}
        alignItems="center"
        cursor={"pointer"}
        onClick={handleGoBack}
      >
        <IoChevronBackCircleSharp color={"#52BBFF"} size={30} />
        &nbsp;
        <Text
          color={"#52BBFF"}
          fontSize={{ base: "sm", md: "sm", lg: "md" }}
          fontWeight={"800"}
          fontFamily={"font.roboto"}
        >
          Go Back
        </Text>
      </Box>

      <Box marginTop="2rem">
        <Text
          color={"#141D43"}
          fontSize="2xl"
          fontWeight={"800"}
          fontFamily={"font.roboto"}
        >
          Registration Certificate Form
        </Text>
      </Box>

      {/* Header banner */}
      <Box
        marginTop={"1.5rem"}
        bg={
          "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 15%, rgba(164,206,255,1) 100%)"
        }
        color={"#fff"}
        padding={"10px 2rem"}
        fontWeight="700"
        marginLeft={{ base: "-1rem", md: "-2rem", lg: "-5rem" }}
        marginRight={{ base: "-1rem", md: "-2rem", lg: "-4.5rem" }}
        borderTopRightRadius="100px"
        borderBottomRightRadius={"80px 80px"}
        wordBreak="break-word"
        overflowWrap="break-word"
      >
        Application # {application?.id}
      </Box>

      {/* ── Applicant Details Card ── */}
      <Box
        bg="#fff"
        padding={"2rem"}
        marginTop="2rem"
        borderRadius={"15px"}
        overflow="hidden"
        maxW="100%"
      >
        {/* Assignment alert */}
        {application?.status !== "APPROVE" &&
        application?.status !== "REJECT" ? (
          application?.scop_assignedTo?._id !== userData?._id ? (
            <Box marginTop={"10px"} marginBottom="1rem">
              <Alert status="error" borderRadius={"10px"}>
                <AlertIcon />
                <AlertTitle>This application is not assigned by you</AlertTitle>
                <AlertDescription>
                  You need to assign to yourself to approve application
                </AlertDescription>
              </Alert>
            </Box>
          ) : null
        ) : null}

        <Text color={"#141D43"} fontSize="lg" fontWeight={"800"} mb="1rem">
          <Box
            as="span"
            borderRight={"3px solid #2272D5"}
            height="40px"
            marginRight={"1rem"}
          ></Box>
          Applicant Details
        </Text>

        <Box paddingLeft={{ base: "0", md: "1rem", lg: "3rem" }}>
          {/* Org Name */}
          <Box mb="1rem">
            <Text {...labelProps}>Name of Organisation</Text>
            <Text {...valueProps}>
              {application?.scop_company?.name || "N/A"}
            </Text>
          </Box>

          {/* Address */}
          <Box mb="1rem">
            <Text {...labelProps}>Address</Text>
            <Text {...valueProps}>
              {application?.scop_company?.address?.raw_address || "N/A"}
            </Text>
          </Box>

          {/* City / State */}
          <Grid
            width={"100%"}
            templateColumns={{ base: "1fr", sm: "repeat(2, 1fr)" }}
            my={"1rem"}
            gap={{ base: "1rem", md: "2rem" }}
          >
            <GridItem>
              <Text {...labelProps}>City</Text>
              <Text {...valueProps}>
                {application?.scop_company?.address?.city || "N/A"}
              </Text>
            </GridItem>
            <GridItem>
              <Text {...labelProps}>State</Text>
              <Text {...valueProps}>
                {application?.scop_company?.address?.state || "N/A"}
              </Text>
            </GridItem>
          </Grid>

          {/* Pincode / Country */}
          <Grid
            width={"100%"}
            templateColumns={{ base: "1fr", sm: "repeat(2, 1fr)" }}
            my={"1rem"}
            gap={{ base: "1rem", md: "2rem" }}
          >
            <GridItem>
              <Text {...labelProps}>Pincode</Text>
              <Text {...valueProps}>
                {application?.scop_company?.address?.pinCode || "N/A"}
              </Text>
            </GridItem>
            <GridItem>
              <Text {...labelProps}>Country</Text>
              <Text {...valueProps}>
                {application?.scop_company?.address?.country || "N/A"}
              </Text>
            </GridItem>
          </Grid>
        </Box>

        {/* Legal Representative */}
        <Text color={"#141D43"} fontSize="lg" fontWeight={"800"} mb="5px">
          Legal Representative
        </Text>
        <Box
          border={"2px solid #2272D5"}
          width="10%"
          marginBottom={"1rem"}
        ></Box>
        <Box paddingLeft={{ base: "0", md: "1rem", lg: "3rem" }}>
          <Grid
            width={"100%"}
            templateColumns={{
              base: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
            }}
            my={"1rem"}
            gap={{ base: "1rem", md: "1.5rem" }}
          >
            <GridItem>
              <Text {...labelProps}>Name</Text>
              <Text {...valueProps}>
                {application?.scop_company?.legalRepresentative?.name || "N/A"}
              </Text>
            </GridItem>
            <GridItem>
              <Text {...labelProps}>Email</Text>
              <Text {...valueProps}>
                {application?.scop_company?.legalRepresentative?.email || "N/A"}
              </Text>
            </GridItem>
            <GridItem>
              <Text {...labelProps}>Contact</Text>
              <Text {...valueProps}>
                {application?.scop_company?.legalRepresentative?.contact ||
                  "N/A"}
              </Text>
            </GridItem>
          </Grid>
        </Box>

        {/* Point of Contact */}
        <Text color={"#141D43"} fontSize="lg" fontWeight={"800"} mb="5px">
          Point of Contact
        </Text>
        <Box
          border={"2px solid #2272D5"}
          width="10%"
          marginBottom={"1rem"}
        ></Box>
        <Box paddingLeft={{ base: "0", md: "1rem", lg: "3rem" }}>
          {/* Name / Email / Contact */}
          <Grid
            width={"100%"}
            templateColumns={{
              base: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
            }}
            my={"1rem"}
            gap={{ base: "1rem", md: "1.5rem" }}
          >
            <GridItem>
              <Text {...labelProps}>Name</Text>
              <Text {...valueProps}>
                {application?.scop_company?.contactPerson?.name || "N/A"}
              </Text>
            </GridItem>
            <GridItem>
              <Text {...labelProps}>Email</Text>
              <Text {...valueProps}>
                {application?.scop_company?.contactPerson?.email || "N/A"}
              </Text>
            </GridItem>
            <GridItem>
              <Text {...labelProps}>Contact</Text>
              <Text {...valueProps}>
                {application?.scop_company?.contactPerson?.contact || "N/A"}
              </Text>
            </GridItem>
          </Grid>

          {/* Org Email / Contact Number */}
          <Grid
            width={"100%"}
            templateColumns={{ base: "1fr", sm: "repeat(2, 1fr)" }}
            my={"1rem"}
            gap={{ base: "1rem", md: "2rem" }}
          >
            <GridItem>
              <Text {...labelProps}>Organization Email</Text>
              <Text {...valueProps}>
                {application?.scop_company?.contactPerson?.email || "N/A"}
              </Text>
            </GridItem>
            <GridItem>
              <Text {...labelProps}>Contact Number</Text>
              <Text {...valueProps}>
                {application?.scop_company?.contactPerson?.contact || "N/A"}
              </Text>
            </GridItem>
          </Grid>

          {/* Website */}
          <Box my={"1rem"}>
            <Text {...labelProps}>Website/Url</Text>
            <a
              href={`${application?.website}`}
              target="_blank"
              rel="noreferrer"
            >
              <Text {...valueProps} wordBreak="break-all">
                {application?.website || "N/A"}
              </Text>
            </a>
          </Box>

          {/* Description */}
          <Box my={"1rem"}>
            <Text {...labelProps}>Brief Description about Organisation</Text>
            <Text {...valueProps}>{application?.description || "N/A"}</Text>
          </Box>
        </Box>
      </Box>

      {/* ── Applicant Details and Scope Card ── */}
      <Box
        bg="#fff"
        padding={"2rem"}
        marginTop="2rem"
        borderRadius={"15px"}
        overflow="hidden"
        maxW="100%"
      >
        <Text color={"#141D43"} fontSize="lg" fontWeight={"800"} mb="1rem">
          <Box
            as="span"
            borderRight={"3px solid #2272D5"}
            height="40px"
            marginRight={"1rem"}
          ></Box>
          Applicant Details and scope
        </Text>

        {application?.scop_units?.map((unit, unitIndex) => (
          <Box
            key={unitIndex}
            paddingLeft={{ base: "0", md: "1rem", lg: "3rem" }}
          >
            {/* Facility / Employees */}
            <Grid
              width={"100%"}
              templateColumns={{ base: "1fr", sm: "repeat(2, 1fr)" }}
              my={"1rem"}
              gap={{ base: "1rem", md: "2rem" }}
            >
              <GridItem>
                <Text {...labelProps}>Facility/Site Name</Text>
                <Text {...valueProps}>{unit?.name || "N/A"}</Text>
              </GridItem>
              <GridItem>
                <Text {...labelProps}>Number Of Employees</Text>
                <Text {...valueProps}>{unit?.numberOfEmployees || "N/A"}</Text>
              </GridItem>
            </Grid>

            {/* Address */}
            <Box mb="1rem">
              <Text {...labelProps}>Address</Text>
              <Text {...valueProps}>{unit?.address?.raw_address || "N/A"}</Text>
            </Box>

            {/* City / State */}
            <Grid
              width={"100%"}
              templateColumns={{ base: "1fr", sm: "repeat(2, 1fr)" }}
              my={"1rem"}
              gap={{ base: "1rem", md: "2rem" }}
            >
              <GridItem>
                <Text {...labelProps}>City</Text>
                <Text {...valueProps}>{unit?.address?.city || "N/A"}</Text>
              </GridItem>
              <GridItem>
                <Text {...labelProps}>State</Text>
                <Text {...valueProps}>{unit?.address?.state || "N/A"}</Text>
              </GridItem>
            </Grid>

            {/* Pincode / Country */}
            <Grid
              width={"100%"}
              templateColumns={{ base: "1fr", sm: "repeat(2, 1fr)" }}
              my={"1rem"}
              gap={{ base: "1rem", md: "2rem" }}
            >
              <GridItem>
                <Text {...labelProps}>Pincode</Text>
                <Text {...valueProps}>{unit?.address?.pinCode || "N/A"}</Text>
              </GridItem>
              <GridItem>
                <Text {...labelProps}>Country</Text>
                <Text {...valueProps}>{unit?.address?.country || "N/A"}</Text>
              </GridItem>
            </Grid>

            {/* Type of Org */}
            <Box my={"1rem"}>
              <Text {...labelProps}>Type of organization</Text>
              <Text {...valueProps}>{unit?.unitType || "N/A"}</Text>
            </Box>

            {/* Process Badges */}
            <Box my={"1rem"}>
              <Text {...labelProps}>Type of Process</Text>
              {unit?.processIds?.length > 0 ? (
                <Box display="flex" flexWrap="wrap" gap="0.5rem" mt="1rem">
                  {unit?.unit_processes?.map((name, i) => (
                    <Badge
                      key={i}
                      fontSize="md"
                      cursor={"pointer"}
                      whiteSpace="normal"
                      wordBreak="break-word"
                      padding="0.25rem 0.5rem"
                    >
                      {name?.name}
                    </Badge>
                  ))}
                </Box>
              ) : (
                <Text mt="1rem">No processes available</Text>
              )}
            </Box>

            {/* Program Badges */}
            <Box my={"1rem"}>
              <Text {...labelProps}>Selected Programs</Text>
              {unit?.programIds?.length > 0 ? (
                <Box display="flex" flexWrap="wrap" gap="0.5rem" mt="1rem">
                  {unit?.unit_programs?.map((name, i) => (
                    <Badge
                      key={i}
                      fontSize="md"
                      cursor={"pointer"}
                      whiteSpace="normal"
                      wordBreak="break-word"
                      padding="0.25rem 0.5rem"
                    >
                      {name?.id}
                    </Badge>
                  ))}
                </Box>
              ) : (
                <Text mt="1rem">No programs available</Text>
              )}
            </Box>

            <Box w={"100%"} h={"1px"} bg="gray"></Box>
          </Box>
        ))}
      </Box>

      {/* ── RC Documents ── */}
      <Box
        marginTop="2rem"
        bg="#FFFFFF"
        borderRadius={"15px"}
        p={"2rem"}
        overflow="hidden"
        maxW="100%"
      >
        <Text color={"#141D43"} fontSize="lg" fontWeight={"800"} pb="1rem">
          RC Documents
        </Text>
        {application?.application_documentsForVerification?.length > 0 ? (
          <DocumentViewer
            document={application?.application_documentsForVerification}
            referenceId={application?._id}
            doc_from={DOCUMENT_FROM.APPLICATION}
          />
        ) : (
          <Box
            bg="#FFFFFF"
            w={"175px"}
            h={"125px"}
            borderRadius={"15px"}
            textAlign="center"
            display="flex"
            alignItems="center"
            mb="1rem"
            boxShadow={"rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}
          >
            <Text padding={"1rem"}>No Application Document Found</Text>
          </Box>
        )}
      </Box>

      {/* ── Product Details ── */}
      <Box
        bg="#fff"
        borderRadius={"15px"}
        padding={{ base: "1rem", md: "2rem", lg: "3rem" }}
        mt="2rem"
        overflow="hidden"
        maxW="100%"
      >
        <Text color={"#141D43"} fontSize="lg" fontWeight={"800"} mb="1rem">
          <Box
            as="span"
            borderRight={"3px solid #2272D5"}
            height="40px"
            marginRight={"1rem"}
          ></Box>
          Product Details
        </Text>

        {application?.scop_products?.length > 0 ? (
          <>
            {/* Header row */}
            <Grid
              padding={{ base: "0.5rem", md: "1rem" }}
              mt={{ base: "1rem", md: "2rem" }}
              templateColumns={{ base: "1fr 1fr", lg: "repeat(3, 1fr)" }}
              rowGap={{ base: "0.5rem", md: "1rem" }}
              columnGap={{ base: "0.5rem", md: "1rem" }}
            >
              <GridItem>
                <Text fontWeight={"700"}>Product Name</Text>
              </GridItem>
              <GridItem>
                <Text fontWeight={"700"}>Product Category</Text>
              </GridItem>
              <GridItem display={{ base: "none", lg: "block" }}>
                <Text fontWeight={"700"}>Product Classification</Text>
              </GridItem>
            </Grid>

            {application?.scop_products?.map((product, pi) => (
              <Grid
                key={pi}
                padding={{ base: "0.5rem", md: "1rem" }}
                templateColumns={{ base: "1fr 1fr", lg: "repeat(3, 1fr)" }}
                rowGap={{ base: "0.5rem", md: "1rem" }}
                columnGap={{ base: "0.5rem", md: "1rem" }}
              >
                <GridItem>
                  <Text wordBreak="break-word" overflowWrap="break-word">
                    {product?.name || "N/A"}
                  </Text>
                </GridItem>
                <GridItem>
                  <Text wordBreak="break-word" overflowWrap="break-word">
                    {product?.product_productCategory?.name || "N/A"}
                  </Text>
                </GridItem>
                <GridItem>
                  <Text wordBreak="break-word" overflowWrap="break-word">
                    {product?.product_productClassification?.name || "N/A"}
                  </Text>
                </GridItem>
              </Grid>
            ))}
          </>
        ) : (
          <Box mt="2rem" p={"1rem"}>
            No product details available
          </Box>
        )}
      </Box>

      {/* ── File Upload Section ── */}
      {application?.status === "APPROVE" || application?.status === "REJECT" ? (
        <Box
          bg="#FFFFFF"
          borderRadius={"15px"}
          padding={"2rem"}
          marginTop="2rem"
          overflow="hidden"
          maxW="100%"
        >
          <Text
            color={"#141D43"}
            fontSize="lg"
            fontWeight={"800"}
            padding="0.5rem"
          >
            Contractor uploaded Documents
          </Text>
          <Grid
            margin={{ base: "0.5rem", md: "1rem" }}
            templateColumns={{
              base: "1fr",
              sm: "repeat(2, 1fr)",
              lg: "repeat(6, 1fr)",
            }}
            gap={{ base: 2, md: 3, lg: 4 }}
          >
            <DocumentViewer
              document={application?.applicationForm_offerLetter}
              referenceId={application?._id}
              doc_from={DOCUMENT_FROM.APPLICATION}
            />
            <DocumentViewer
              document={application?.application_paymentReference}
              referenceId={application?._id}
              doc_from={DOCUMENT_FROM.APPLICATION}
            />
          </Grid>
        </Box>
      ) : (
        <Box>
          {userData?._id === application?.scop_assignedTo?._id ? (
            <Box>
              <Grid
                mt={"1rem"}
                templateColumns={{
                  base: "1fr",
                  sm: "repeat(2, 1fr)",
                  lg: "repeat(6, 1fr)",
                }}
                gap={"2rem"}
              >
                <GridItem colSpan={1}>
                  <Button
                    bg="#fff"
                    color={"#3958DC"}
                    width={{ base: "100%", md: "250px" }}
                    height={"164px"}
                    leftIcon={<FiUpload />}
                    borderRadius={"15px"}
                    as="label"
                    htmlFor="file-upload"
                    variant="outline"
                  >
                    Payment Reference
                    <VisuallyHidden>
                      <input
                        id="file-upload"
                        type="file"
                        onChange={handleFileUpload}
                      />
                    </VisuallyHidden>
                  </Button>
                </GridItem>
                {paymentFile && (
                  <GridItem colSpan={1}>
                    <Box display={"flex"} className="overflow-style">
                      <Box
                        bg="#FFFFFF"
                        w={{ base: "100%", md: "250px" }}
                        h={"164px"}
                        borderRadius={"15px"}
                      >
                        <Box display={"flex"} justifyContent={"right"}>
                          <Button
                            borderColor="#FFFFFF"
                            bg="#ffffff"
                            size="sm"
                            variant="outline"
                            onClick={() => setPaymentFile()}
                            leftIcon={<RemoveIcon />}
                          ></Button>
                        </Box>
                        <Box display={"flex"} justifyContent={"center"}>
                          <FileIcon />
                        </Box>
                        <Tooltip label={paymentFile?.name}>
                          <Text
                            margin={"auto"}
                            width={"130px"}
                            whiteSpace={"nowrap"}
                            overflow={"hidden"}
                            textOverflow={"ellipsis"}
                          >
                            {paymentFile?.name}
                          </Text>
                        </Tooltip>
                      </Box>
                    </Box>
                  </GridItem>
                )}
                <GridItem colSpan={1}>
                  <Button
                    bg="#fff"
                    color={"#3958DC"}
                    width={{ base: "100%", md: "230px" }}
                    height={"164px"}
                    leftIcon={<FiUpload />}
                    borderRadius={"15px"}
                    as="label"
                    htmlFor="file-upload-offerletter"
                    variant="outline"
                  >
                    Offer letter
                    <VisuallyHidden>
                      <input
                        id="file-upload-offerletter"
                        type="file"
                        onChange={handleOfferUpload}
                      />
                    </VisuallyHidden>
                  </Button>
                </GridItem>
                {offerLetterFile && (
                  <GridItem colSpan={1}>
                    <Box display={"flex"} className="overflow-style">
                      <Box
                        bg="#FFFFFF"
                        w={{ base: "100%", md: "230px" }}
                        h={"164px"}
                        borderRadius={"15px"}
                      >
                        <Box display={"flex"} justifyContent={"right"}>
                          <Button
                            borderColor="#FFFFFF"
                            bg="#ffffff"
                            size="sm"
                            variant="outline"
                            onClick={() => setOfferLetterFile()}
                            leftIcon={<RemoveIcon />}
                          ></Button>
                        </Box>
                        <Box display={"flex"} justifyContent={"center"}>
                          <FileIcon />
                        </Box>
                        <Tooltip label={offerLetterFile?.name}>
                          <Text
                            margin={"auto"}
                            width={"130px"}
                            whiteSpace={"nowrap"}
                            overflow={"hidden"}
                            textOverflow={"ellipsis"}
                          >
                            {offerLetterFile?.name}
                          </Text>
                        </Tooltip>
                      </Box>
                    </Box>
                  </GridItem>
                )}
              </Grid>

              <Box mt="1rem" display={"flex"} justifyContent={"center"}>
                {errorMessage && (
                  <Box
                    bg="crimson"
                    color="white"
                    p="1rem"
                    borderRadius="15px"
                    mb="1rem"
                    w={{ base: "100%", md: "60%" }}
                    textAlign={"center"}
                  >
                    {errorMessage}
                    <Button
                      size="sm"
                      variant="outline"
                      ml="1rem"
                      bg="white"
                      color="black"
                      onClick={clearErrorMessage}
                    >
                      <RemoveIcon />
                    </Button>
                  </Box>
                )}
              </Box>
              <Box mt="1rem" display={"flex"} justifyContent={"center"}>
                {errorMessage1 && (
                  <Box
                    bg="crimson"
                    color="white"
                    p="1rem"
                    borderRadius="15px"
                    mb="1rem"
                    w={{ base: "100%", md: "60%" }}
                    textAlign={"center"}
                  >
                    {errorMessage1}
                    <Button
                      size="sm"
                      variant="outline"
                      ml="1rem"
                      bg="white"
                      color="black"
                      onClick={clearErrorMessage1}
                    >
                      <RemoveIcon />
                    </Button>
                  </Box>
                )}
              </Box>
            </Box>
          ) : (
            <Box></Box>
          )}
        </Box>
      )}

      {/* ── Remarks Table ── */}
      {userData?.role?.includes("ADMIN") ||
      userData?.role?.includes("CONTRACTOR") ? (
        application?.status !== "ASSIGNED" ? (
          <Grid
            templateColumns="repeat(1, 1fr)"
            style={{ paddingLeft: "0 !important" }}
            width={"100%"}
          >
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
              margin={"1rem"}
            >
              Remarks
            </Text>
            <GridItem
              width={"100%"}
              overflowY={"scroll"}
              className="overflow-style"
            >
              <TableContainer className="overflow-style">
                <Table
                  variant={"simple"}
                  size="md"
                  bg={"#fff"}
                  borderRadius={"15px"}
                  pr={"1rem"}
                >
                  <Thead>
                    <Tr>
                      <Th color="brand.blue" textTransform="capitalize">
                        Sr no.
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Date Time
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Comment by
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Remarks
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {remarks?.length ? (
                      remarks.map((remark, index) => (
                        <Tr key={index}>
                          <Td>{index + 1}</Td>
                          <Td>
                            {moment(remark?.time).format("DD-MM-YYYY hh:mm")}
                          </Td>
                          <Td>
                            {remark.userId &&
                              `${remark?.userId?.name} (${remark?.userId?.id})`}
                          </Td>
                          <Td>{remark?.comment || "N/A"}</Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr>
                        <Td colSpan="4" textAlign="center" fontWeight={"700"}>
                          No remarks for now
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            </GridItem>
          </Grid>
        ) : null
      ) : null}

      {/* ── Logs Table ── */}
      {userData?.role?.includes("ADMIN") ? (
        <Grid
          templateColumns="repeat(1, 1fr)"
          style={{ paddingLeft: "0 !important" }}
          width={"100%"}
        >
          <Text
            color={"#141D43"}
            fontSize="md"
            fontWeight={"700"}
            fontFamily={"font.roboto"}
            margin={"1rem"}
          >
            Logs
          </Text>
          <GridItem
            width={"100%"}
            overflowY={"scroll"}
            className="overflow-style"
          >
            <TableContainer className="overflow-style">
              <Table
                variant={"simple"}
                size="md"
                bg={"#fff"}
                borderRadius={"15px"}
                pr={"1rem"}
              >
                <Thead>
                  <Tr>
                    <Th color="brand.blue" textTransform="capitalize">
                      Sr no.
                    </Th>
                    <Th color="brand.blue" textTransform="capitalize">
                      Date Time
                    </Th>
                    <Th color="brand.blue" textTransform="capitalize">
                      User
                    </Th>
                    <Th color="brand.blue" textTransform="capitalize">
                      Logs
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {application?.remarks?.length ? (
                    application?.remarks?.map((remark, index) => (
                      <Tr key={index}>
                        <Td>{index + 1}</Td>
                        <Td>
                          {moment(remark?.time).format("DD-MM-YYYY hh:mm")}
                        </Td>
                        <Td>
                          {remark.userId &&
                            `${remark?.userId?.name} (${remark?.userId?.id})`}
                        </Td>
                        <Td>{remark?.log || "N/A"}</Td>
                      </Tr>
                    ))
                  ) : (
                    <Tr>
                      <Td colSpan="4" textAlign="center" fontWeight={"700"}>
                        No logs for now
                      </Td>
                    </Tr>
                  )}
                </Tbody>
              </Table>
            </TableContainer>
          </GridItem>
        </Grid>
      ) : null}

      {/* ── Remarks Textarea ── */}
      {application?.status === "REJECT" ||
      application?.status === "APPROVE" ||
      application?.status === "" ? (
        <Box mt="1rem"></Box>
      ) : (
        <Box>
          {userData?._id === application?.scop_assignedTo?._id ? (
            <Grid
              mt={{ base: "1.5rem", md: "2rem" }}
              templateColumns={{
                base: "1fr",
                md: "repeat(2, 1fr)",
                lg: "repeat(4, 1fr)",
              }}
              gap={{ base: "1rem", md: "1.5rem", lg: "2rem" }}
            >
              <GridItem>
                <Textarea
                  type="tel"
                  color={"#141D43"}
                  border="none"
                  width={{ base: "100%", md: "100%", lg: "522px" }}
                  height={{ base: "120px", md: "150px", lg: "164px" }}
                  bg={"#fff"}
                  placeholder="Remarks"
                  fontSize={"16px"}
                  borderRadius={"15px"}
                  fontWeight={"400"}
                  onChange={(e) => setComment(e.target.value)}
                />
              </GridItem>
            </Grid>
          ) : (
            <Box></Box>
          )}
        </Box>
      )}

      {/* ── Action Buttons ── */}
      {application?.status === "REJECT" ||
      application?.status === "APPROVE" ||
      application?.status === "" ? (
        <Box mt={"2rem"}></Box>
      ) : (
        <Box mt={"2rem"}>
          <ButtonGroup gap={2} flexWrap="wrap">
            {application?.scop_assignedTo?._id === userData?._id ? (
              <ButtonGroup gap={2} flexWrap="wrap">
                <Button
                  bg="brand.secondaryColor"
                  color="brand.white"
                  colorScheme="brand.secondaryColor"
                  w={{ base: "100%", md: "171px" }}
                  h="60px"
                  disabled={isLoading ? true : false}
                  onClick={() => setIsOpenMod(true)}
                >
                  Approve
                </Button>
                <Button
                  bg="crimson"
                  color="brand.white"
                  colorScheme="brand.secondaryColor"
                  w={{ base: "100%", md: "171px" }}
                  h="60px"
                  disabled={isLoading ? true : ""}
                  onClick={() => setIsOpen(true)}
                >
                  Reject
                </Button>
              </ButtonGroup>
            ) : (
              <Box
                bg="brand.gray"
                boxShadow={"rgba(100, 100, 111, 0.2) 0px 20px 50px 0px"}
                w={{ base: "100%", md: "300px" }}
                h="60px"
                borderRadius={"15px"}
              >
                <Text
                  p={"5px"}
                  color={"#141D43"}
                  fontWeight={"800"}
                  fontFamily={"font.roboto"}
                  textAlign={"center"}
                >
                  Before performing any action, assign this application.
                </Text>
              </Box>
            )}

            {application?.scop_assignedTo?._id === userData?._id ? (
              <Box
                bg="brand.gray"
                boxShadow={"rgba(100, 100, 111, 0.2) 0px 20px 50px 0px"}
                w={{ base: "100%", md: "300px" }}
                h="60px"
                borderRadius={"15px"}
              >
                <Text
                  p={"5px"}
                  color={"#141D43"}
                  fontWeight={"800"}
                  fontFamily={"font.roboto"}
                  textAlign={"center"}
                >
                  You are currently assigned to this application.
                </Text>
              </Box>
            ) : (
              <Button
                bg="brand.lightGreen"
                color="brand.white"
                colorScheme="brand.lightGreen"
                w={{ base: "100%", md: "193px" }}
                h="60px"
                disabled={isLoading ? true : ""}
                onClick={() => assignToMe(encodeURIComponent(id))}
              >
                Assign to me
              </Button>
            )}
          </ButtonGroup>
        </Box>
      )}

      <CustomAlertDialog
        isOpen={isOpen}
        onClose={onClose}
        title="Are you sure?"
        content="This action cannot be undone. Do you want to continue?"
        cancelButtonText="Cancel"
        confirmButtonText="Confirm"
        cancelButtonColor="gray"
        confirmButtonColor="red"
        onConfirm={() => rejectApplicationForm(encodeURIComponent(id))}
      />

      <CustomAlertDialog
        isOpen={isOpenMod}
        onClose={onCloseMod}
        title="Are you sure?"
        content="This action cannot be undone. Do you want to continue?"
        cancelButtonText="Cancel"
        confirmButtonText="Confirm"
        cancelButtonColor="gray"
        confirmButtonColor="#52BBFF"
        onConfirm={handleSubmit}
      />
    </Box>
  );
}

export default isAllowed(RCFormUploadDocuments);
